import React, { useState,useEffect } from 'react';
import CommonModal from '@components/common/CommonModal';
import ButtonModal from '@components/common/Button';
import './ReferralView.css';
import InputFieldsComponent from '@components/common/InputFieldsSmall';

interface ManageReferralProps {
  handleCloseModal: () => void;
  showWarningModal: any;
  handleWarningModalBackButton: () => void;
  handleFinalSubmit: (statusId: string, comment: string,status:string) => void;
  handleCommentChange:(comment:string) => void;
  referredStatus:any[];
  handleOptionChange:(id:string) => void;
}

const ManageReferralModal: React.FC<ManageReferralProps> = ({
  handleCloseModal,
  showWarningModal,
  handleWarningModalBackButton,
  handleFinalSubmit,
  handleCommentChange,
  referredStatus,
  handleOptionChange
}) => {
  const [selected, setSelected] = useState<any>('managed');
  const [commentText, setCommentText] = useState<any>('');
  const [selectedStatusId, setSelectedStatusId] = useState<string>(referredStatus[0].facility_referral_status_id);

  useEffect(() => {
    handleOptionChange(selectedStatusId);
  }, [selectedStatusId, handleOptionChange]);


  const handleClick = (option: any) => {
    const statusId = option === 'managed' ? referredStatus[0].facility_referral_status_id : referredStatus[1].facility_referral_status_id;
    setSelectedStatusId(statusId);
    setSelected(option)
  };


  handleOptionChange(selectedStatusId)

  const handleSubmit = () => {
    handleFinalSubmit(selectedStatusId, commentText,selected);
  };

  
  

  const handleChange = (event:any) => {
    const newComment = event;
    setCommentText(newComment);
    handleCommentChange(newComment)
  };


  return (
    <CommonModal
      show={showWarningModal}
      handleClose={handleCloseModal}
      handleCustomBackButton={handleWarningModalBackButton}
      conditionalClass="modal_component dynamic_form_field"
      showCustomHeader={true}
      title=""
      size="md"
      footer={
        <>
          <ButtonModal
            onClick={handleSubmit}
            id="cancel"
            buttonName={'Submit'}
            colorType={'primary'}
          />
        </>
      }
    >
      <div className="referral-modal">
        <div className="referral-header-text">Manage Referral</div>
        <div className="sub-heading-text">
          Referral Status <span className="star">*</span>
        </div>
        <div className="button-container">
          <div
            className={`referral-button-wrapper ${selected === 'managed' ? 'selected' : ''}`}
            onClick={() => handleClick('managed')}
          >
            {referredStatus[0].facility_referral_status_name}
          </div>
          <div
            className={`referral-button-wrapper ${selected === 'rejected' ? 'selected' : ''}`}
            onClick={() => handleClick('rejected')}
          >
            {referredStatus[1].facility_referral_status_name}
          </div>
        </div>
        <InputFieldsComponent
          inputType={'general'}
          placeholder={'Type Here'}
          type={'text'}
          onChange={handleChange}
          isDisabled={false}
          labelName="Comment"
        />
      </div>
    </CommonModal>
  );
};

export default ManageReferralModal;
